import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { TileWrapperProps } from '@widgets/Teaser/toi/types'
import Blink from '@components/Blink'

const StyledTileWrapper = styled(Blink)`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  border-right: 2px white solid;
  padding: 8px;
  box-sizing: border-box;
  height: 80px;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
`

const TileWrapper: FunctionComponent<TileWrapperProps> = ({
  children,
  clickableProps,
}) => {
  return (
    <StyledTileWrapper
      {...clickableProps}
      {...(typeof clickableProps?.title === 'string'
        ? { ariaLabel: clickableProps.title }
        : {})}>
      {children}
    </StyledTileWrapper>
  )
}

export default TileWrapper
